import { useState, useEffect } from "react";

export default function BudgetGame({onComplete,color,dark,tier='builder'}){
  const CONFIG=tier==='starter'?{total:100,step:10,label:'$100 Allowance Month'}:
               tier==='master' ?{total:3000,step:150,label:'$3,000 Monthly Paycheck'}:
                                {total:600,step:25,label:'$600 Part-Time Paycheck'};
  const JARS=[{id:'needs',label:'🏠 Needs',target:CONFIG.total*0.5,clr:'#10b981',tip:'50%'},{id:'wants',label:'🎮 Wants',target:CONFIG.total*0.3,clr:'#f59e0b',tip:'30%'},{id:'save',label:'🐷 Save',target:CONFIG.total*0.2,clr:'#3b82f6',tip:'20%'}];
  const [vals,setVals]=useState({needs:0,wants:0,save:0});
  const placed=Object.values(vals).reduce((a,b)=>a+b,0);
  const remaining=CONFIG.total-placed;
  const allPlaced=placed>=CONFIG.total;
  useEffect(()=>{if(allPlaced)setTimeout(onComplete,900);},[allPlaced]);
  function addToJar(id){if(remaining>0)setVals(v=>({...v,[id]:Math.min(CONFIG.total,v[id]+CONFIG.step)}))}
  function removeFromJar(id){setVals(v=>({...v,[id]:Math.max(0,v[id]-CONFIG.step)}))}
  return(
    <div style={{fontFamily:'Nunito',userSelect:'none'}}>
      <p style={{fontSize:13,fontWeight:800,color:'#374151',textAlign:'center',marginBottom:4}}>🎮 Fill the jars following the 50/30/20 rule! ({CONFIG.label})</p>
      <div style={{textAlign:'center',fontSize:12,color:'#6b7280',fontWeight:700,marginBottom:8}}>💵 ${remaining} left • tap to add ${CONFIG.step} • long-press to remove</div>
      <div style={{display:'flex',flexWrap:'wrap',gap:5,justifyContent:'center',background:'#f9fafb',borderRadius:12,padding:'8px',border:'2px dashed #d1d5db',marginBottom:10,minHeight:44}}>
        {Array.from({length:Math.max(0,remaining/CONFIG.step)}).map((_,i)=>(
          <div key={i} style={{fontSize:22,cursor:'default',filter:'drop-shadow(0 2px 4px rgba(0,0,0,0.15))'}}>🪙</div>
        ))}
        {allPlaced&&<span style={{fontSize:13,fontWeight:800,color,alignSelf:'center'}}>All placed! 🎉</span>}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
        {JARS.map(j=>{const onTarget=vals[j.id]===j.target;const over=vals[j.id]>j.target;return(
          <div key={j.id} onClick={()=>addToJar(j.id)} onContextMenu={e=>{e.preventDefault();removeFromJar(j.id);}}
            style={{background:onTarget?j.clr+'25':over?'#fee2e2':'#fff',border:`2.5px dashed ${vals[j.id]>0?j.clr:'#d1d5db'}`,
              borderRadius:16,padding:'10px 6px',textAlign:'center',cursor:'pointer',transition:'all 0.2s',minHeight:90}}>
            <div style={{fontSize:11,fontWeight:900,color:j.clr,marginBottom:2}}>{j.label}</div>
            <div style={{fontSize:10,color:'#9ca3af',fontWeight:700,marginBottom:5}}>Target: {j.tip}</div>
            <div style={{background:'#e5e7eb',borderRadius:20,height:7,overflow:'hidden',margin:'0 2px 5px'}}>
              <div style={{width:`${Math.min(100,vals[j.id]/j.target*100)}%`,height:'100%',background:over?'#ef4444':onTarget?'#10b981':j.clr,borderRadius:20,transition:'width 0.3s'}}/>
            </div>
            <div style={{fontSize:14,fontWeight:900,color:onTarget?'#10b981':over?'#ef4444':j.clr}}>${vals[j.id]}</div>
            {onTarget&&<div style={{fontSize:10,fontWeight:800,color:'#10b981'}}>✅ Perfect!</div>}
            {over&&<div style={{fontSize:10,fontWeight:800,color:'#ef4444'}}>Too much!</div>}
          </div>);})}
      </div>
    </div>
  );
}
